import moment from 'moment';
import 'moment/locale/vi';

export default function Notification({
    title,
    date
}: {
    title: string;
    date: string;
}) {
    // Lấy locale từ localStorage để đồng bộ với i18n
    const locale = localStorage.getItem("language");
    moment.locale(locale === 'VI' ? 'vi' : 'en');

    return (
        <div style={{
            width: '100%', display: 'flex', gap: '12px', justifyContent: 'space-between',
            alignItems: 'start', marginBottom: '10px',
        }}>
            <span
                style={{ color: '#262626', fontSize: 12, fontWeight: '400', maxWidth: '258px', lineHeight: '16px' }}
                dangerouslySetInnerHTML={{ __html: title }}
            />
            <span style={{ color: '#021C5E', fontSize: 12, fontWeight: '500', whiteSpace: 'nowrap' }}>
                {moment(date).fromNow()}
            </span>
        </div>
    );
}